import { CaseCountResponse, CaseResponse, CaseSearch, CaseTypeCodes, UserAccountResponse } from './model';

export const enum CaseActionTypes {
  FETCH_CASES = '@@case/FETCH_CASES',
  FETCH_CASES_SUCCESS = '@@case/FETCH_CASES_SUCCESS',
  FETCH_CASES_FAIL = '@@case/FETCH_CASES_FAIL',
  SET_SEARCH_CASE = '@@case/SET_SEARCH_CASE',
  FETCH_CASE_FOR_MOBILE = '@@case/FETCH_CASE_FOR_MOBILE',
  FETCH_CASE_FOR_MOBILE_SUCCESS = '@@case/FETCH_CASE_FOR_MOBILE_SUCCESS',
  FETCH_CASE_FOR_MOBILE_FAIL = '@@case/FETCH_CASE_FOR_MOBILE_FAIL',
  SET_NO_CASE_FOUND_MESSAGE = '@@case/SET_NO_CASE_FOUND_MESSAGE',
  CLEAR_CASES = '@@case/CLEAR_CASES',
  SHOW_SEARCH_BAR = '@@case/SHOW_SEARCH_BAR',
  SELECT_CASE = '@@case/SELECT_CASE',
  UPDATE_SELECTED_PAGE = '@@case/UPDATE_SELECTED_PAGE',
  REFUSE_CASE = '@@case/REFUSE_CASE',
  REFUSE_CASE_FAIL = '@@case/REFUSE_CASE_FAIL',
  REFUSE_CASE_SUCCESS = '@@case/REFUSE_CASE_SUCCESS',
  REFUSE_CASE_OPEN = '@@case/REFUSE_CASE_OPEN',
  REFUSE_CASE_CLOSE = '@@case/REFUSE_CASE_CLOSE',
  ARCHIVE_CASE = '@@case/ARCHIVE_CASE',
  ARCHIVE_CASE_FAIL = '@@case/ARCHIVE_CASE_FAIL',
  ARCHIVE_CASE_SUCCESS = '@@case/ARCHIVE_CASE_SUCCESS',
  DEARCHIVE_CASE = '@@case/DEARCHIVE_CASE',
  DEARCHIVE_CASE_FAIL = '@@case/DEARCHIVE_CASE_FAIL',
  DEARCHIVE_CASE_SUCCESS = '@@case/DEARCHIVE_CASE_SUCCESS',
  ARCHIVE_CASE_OPEN = '@@case/ARCHIVE_CASE_OPEN',
  ARCHIVE_CASE_CLOSE = '@@case/ARCHIVE_CASE_CLOSE',
  REFUSE_REASON_CHANGE = '@@case/REFUSE_REASON_CHANGE',
  REFUSE_REASON_TEXT_CHANGE = '@@case/REFUSE_REASON_TEXT_CHANGE',
  FETCH_CASE_TYPECODES_SUCCESS = '@@case/FETCH_CASE_TYPECODES_SUCCESS',
  FETCH_CASE_TYPECODES_FAIL = '@@case/FETCH_CASE_TYPECODES_FAIL',
  ASSIGN_USER_OPEN = '@@case/ASSIGN_USER_OPEN',
  ASSIGN_USER_OPEN_SUCCESS = '@@case/ASSIGN_USER_OPEN_SUCCESS',
  ASSIGN_USER_OPEN_FAIL = '@@case/ASSIGN_USER_OPEN_FAIL',
  ASSIGN_USER_CLOSE = '@@case/ASSIGN_USER_CLOSE',
  ASSIGN_USER = '@@case/ASSIGN_USER',
  ASSIGN_USER_SUCCESS = '@@case/ASSIGN_USER_SUCCESS',
  ASSIGN_USER_FAIL = '@@case/ASSIGN_USER_FAIL',
  CHANGE_ASSIGNED_USER_ID = '@@case/CHANGE_ASSIGNED_USER_ID',
  RESET_STATE = '@@case/RESET_CASES',
  FETCH_CASES_COUNT = '@@case/FETCH_CASES_COUNT',
  FETCH_CASES_COUNT_SUCCESS = '@@case/FETCH_CASES_COUNT_SUCCESS',
  FETCH_CASES_COUNT_FAIL = '@@case/FETCH_CASES_COUNT_FAIL',
  MARK_AS_READ_FAIL = '@@case/MARK_AS_READ_FAIL',
  MARK_AS_READ_SUCCESS = '@@case/MARK_AS_READ_SUCCESS',
  SET_DOCUMENTS_FOR_APPROVAL_COUNT_FOR_ALL_CASES = '@@case/SET_DOCUMENTS_FOR_APPROVAL_COUNT_FOR_ALL_CASES',
  FETCH_PARTIES = '@@case/FETCH_PARTIES',
  FETCH_PARTIES_SUCCESS = '@@case/FETCH_PARTIES_SUCCESS',
  FETCH_PARTIES_ERROR = '@@case/FETCH_PARTIES_ERROR',
  FETCH_CHILD_PARTIES = '@@case/FETCH_CHILD_PARTIES',
  FETCH_CHILD_PARTIES_SUCCESS = '@@case/FETCH_CHILD_PARTIES_SUCCESS',
  FETCH_CHILD_PARTIES_ERROR = '@@case/FETCH_CHILD_PARTIES_ERROR',
  CASE_SEARCH_CHANGE = '@@case/CASE_SEARCH_CHANGE',
  CASE_SEARCH_RESET = '@@case/CASE_SEARCH_RESET',
  FETCH_ASSIGNED_PARTIES = '@@case/FETCH_ASSIGNED_PARTIES',
  FETCH_ASSIGNED_PARTIES_SUCCESS = '@@case/FETCH_ASSIGNED_PARTIES_SUCCESS',
  FETCH_ASSIGNED_PARTIES_ERROR = '@@case/FETCH_ASSIGNED_PARTIES_ERROR',
  SET_IN_PROGRESS_STATE = '@@case/SET_IN_PROGRESS_STATE',
  SET_IN_PROGRESS_STATE_ERROR = '@@case/SET_IN_PROGRESS_STATE_ERROR',
  SET_IN_PROGRESS_STATE_SUCCESS = '@@case/SET_IN_PROGRESS_STATE_SUCCESS',
}

export interface CaseState {
  readonly cases: CaseResponse[];
  readonly offlineCases: CaseResponse[];
  readonly requestSent: boolean;
  readonly caseSearch: CaseSearch;
  readonly searchCase: string;
  readonly caseCount: CaseCountResponse;
  readonly searchBarVisible: boolean;
  readonly refusalModalVisible: boolean;
  readonly archiveModalVisible: boolean;
  readonly selectedCase: CaseResponse;
  readonly caseTypeCodes: CaseTypeCodes;
  readonly showAssignModal: boolean;
  readonly assignableUsers: UserAccountResponse[];
  readonly selectedClaimNotificationId: number;
  readonly selectedAssignedUserId: number | '';
  readonly showCaseNotFoundMessage: boolean;
  readonly hasDocumentsForApproval: number | 0;
}

export type CaseSortColumnType = 'CASE_CODE' | 'ADDRESS' | 'DAMAGE_CAUSE' | 'VISIT_DATE' |
  'START_DATE' | 'EXPERT_NAME' | 'INSURED_PERSON_NAME' | 'ZIP_CODE' | 'RECEIVED_DATE' | 'AGENDA_REF';
